import React from 'react';
import './OutroAnswer.css';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import Heading from '../Heading/Heading';

const OutroAnswer = ({ language, location }) => {

     // get translations
    const {t} = useTranslation();

    // render html
    return(
        <div className={`outroAnswer`}>
            <div className={`outroAnswer__box`}>
                <Heading>{ t('outro_answer_title') }</Heading>
                <p><strong>{ t(`outro_answer_description_${location}`) }</strong></p>
                <div className={`outroAnswer__actions`}>
                    <Button path={`/${location}/${language}`}>{ t('outro_answer_retry') } <span>»</span></Button>
                </div>
            </div>
        </div>
    );
}

export default OutroAnswer;